import React, { useEffect, useState } from 'react';
import { loadStripe } from "@stripe/stripe-js";
import './App.css';
import Processing from './components/Processing';
import { dynamicsService } from "./services/DynamicsService";
import Col100 from './components/Col100';
import Header from './components/Header';
import { Referral } from './types/Referral';

function App() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string>();
  const [referral, setReferral] = useState<Referral>();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const account_id = params.get("account_id");
  const confirm = params.get("confirm");
  const cancel = params.get('cancel');
  const referralId = params.get('referral');
  
  
  // Onload, check fetch Referral
  useEffect(
    () => {
      if (!referralId) return; // do nothing
      if (!account_id) return; // do nothing
      setLoading(true);
      dynamicsService.getReferral(account_id, referralId).then(response => {
        setReferral(response);
        setLoading(false);
      }).catch((err) => {
        setLoading(false);
        setError(err);
      });
    },
    [account_id, referralId]
  );
  async function handleAccept(e: React.FormEvent) {
    e.preventDefault();
    if (!referralId) return;
    setSubmitting(true);
    dynamicsService
        .updateReferral(referralId, 'accept')
        .then(session => {
          setSubmitted(true);
          setSubmitting(false);
        })
        .catch(reason => {
          if (reason) {
            setError(reason);
          }
          else {
            setError("We are unable to mark this referral as Accepted. Please give us a call to work through this error.")
          }
        });
      
      return;  
  }
  async function handleReject(e: React.FormEvent) {
    e.preventDefault();
    if (!referralId) return;
    setSubmitting(true);
    dynamicsService
        .updateReferral(referralId, 'reject')
        .then(session => {
          setSubmitted(true);
          setSubmitting(false);
        })
        .catch(reason => {
          if (reason) {
            setError(reason);
          }
          else {
            setError("We are unable to mark this referral as Accepted. Please give us a call to work through this error.")
          }
        });
      
      return;  
  }
  async function handleSubmit(e: React.FormEvent) {
    const stripe = await loadStripe(window.serviceProviderConfig.stripePublishableKey);
    console.log("handleSubmit", e);
    e.preventDefault();
    setSubmitting(true);
    if (stripe) {
      const baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      dynamicsService
        .createCheckoutSession(account_id ?? "", baseUrl)
        .then(session => {
          stripe
            .redirectToCheckout({ sessionId: session.sessionId })
            .then(result => {
              if (result.error) {
                // If `redirectToCheckout` fails due to a browser or network
                // error, display the localized error message to your customer
                // using `result.error.message`.
                console.error(result.error);
                setError(result.error.message);
              }
            });
        })
        .catch(reason => {
          setError("We are unable to collect a payment method for your account. Please give us a call to work through this error.");
          console.log(reason);
        });
      
      return;    
    }
    console.error("stripe session invalid");
  }

  if (!confirm && !cancel) {
    // TODO crete checkout session
  }

  if (error) {
    return <Col100>
        <strong>ERROR!</strong> {error}
        <button className="elementor-button elementor-button-align-stretch elementor-size-sm" onClick={() => { setSubmitting(false); setError(undefined); }}>
          <span>
            <span className="elementor-align-icon-right elementor-button-icon">
              <i aria-hidden="true" className="fas fa-angle-right" />{" "}
            </span>
            <span className="elementor-button-text">
              Try Again
            </span>
          </span>
        </button>
      </Col100>;
  }
  if (submitting) {
    return <div className="elementor-widget-wrap">
        <Processing />
      </div>;
    
  }
  if (referralId) {
    if (loading) {
      return <div className="elementor-widget-wrap">
          <Processing />
          <div className="elementor-widget-container">
            <div className="elementor-text-editor elementor-clearfix">
              <p>
                Please wait while we fetch this referral.
              </p>
            </div>
          </div>
          
        </div>;
    }
      return <div className="elementor-widget-wrap">
        <Header>Referral {referral?.forza_referralid}</Header>
      <div className="elementor-element elementor-widget elementor-widget-text-editor" data-element_type="widget" data-widget_type="text-editor.default">
        <div className="elementor-widget-container">
          <div className="elementor-text-editor elementor-clearfix">
            {!submitted && <p>
              Would you like to accept or reject this referral?
            </p>}
            {submitted && <p>
              Thank you-- you will receive an email confirmation at {referral?.email} shortly.
              </p>}
          </div>
        </div>
      </div>
      {!submitted &&
      <div className="elementor-element elementor-widget elementor-widget-text-editor" data-element_type="widget" data-widget_type="text-editor.default">
        <div className="elementor-form-fields-wrapper elementor-labels-">
          <strong className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            <label>Service Provider</label>
          </strong>
          <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            {referral?.account}
          </div>
          <strong className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            <label>Email</label>
          </strong>
          <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            {referral?.email}
          </div>
          <strong className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            <label>Client's Zip Code</label>
          </strong>
          <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            {referral?.zipcode}
          </div>
          <strong className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            <label>Service Requested</label>
          </strong>
          <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            {referral?.service}
          </div>
          <strong className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            <label>Description</label>
          </strong>
          <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            {referral?.description}
          </div>
          <strong className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            <label>Referral Fee</label>
          </strong>
          <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50 elementor-field-required">
            ${referral?.price}
          </div>
          <div className="d-flex flex-row">
            <form onSubmit={handleReject} className="order-form elementor-form" id="orderForm" name="OrderForm">
              <div className="elementor-form-fields-wrapper elementor-labels elementor-column-gap-default">
                <div className="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons pt-1">
                  <button type="submit" className="da-button bg-primary">
                    <span>
                      <span className="elementor-align-icon-right elementor-button-icon">
                        <i aria-hidden="true" className="fas fa-angle-right" />{" "}
                      </span>
                      <span className="elementor-button-text">
                        Reject Referral
                      </span>
                    </span>
                  </button>
                </div>
              </div>
            </form>
            <form onSubmit={handleAccept} className="order-form elementor-form" id="orderForm" name="OrderForm">
              <div className="elementor-form-fields-wrapper elementor-labels elementor-column-gap-default">
                <div className="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons pt-1">
                  <button type="submit" className="da-button bg-success">
                    <span>
                      <span className="elementor-align-icon-right elementor-button-icon">
                        <i aria-hidden="true" className="fas fa-angle-right" />{" "}
                      </span>
                      <span className="elementor-button-text">
                        Accept Referral
                      </span>
                    </span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      }

    </div>;
  }
  return <div className="elementor-widget-wrap">
      <form onSubmit={handleSubmit} className="order-form elementor-form" id="orderForm" name="OrderForm">
        <div className="elementor-form-fields-wrapper elementor-labels elementor-column-gap-default">
          <div className="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons pt-1">

            <button type="submit" className="elementor-button elementor-button-align-stretch elementor-size-sm">
              <span>
                <span className="elementor-align-icon-right elementor-button-icon">
                  <i aria-hidden="true" className="fas fa-angle-right" />{" "}
                </span>
                <span className="elementor-button-text">
                  Add a Payment Method to your Account
                </span>
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>;
}

export default App;
